module.exports = __webpack_public_path__ + "static/media/settings.76d73d8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/settings.svg
// module id = 1356
// module chunks = 0